import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty, mergeWith } from 'lodash';
import { useCallback, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { Box } from '@design-system/box';
import { useI18n } from '@design-system/i18n';
import { Label } from '@design-system/label';
import { ScreenReadersContent } from '@design-system/screen-readers-content';
import { useBreakpoint, useTheme, useUpdateThemeWithFontBrightness, } from '@design-system/theme';
import { useGetTags } from './hooks/useTags';
import { TagsFilters } from './TagsFilters';
import { concatArraysCustomizer } from '../../utils';
export const BlockTagsFilters = ({ blockId, blockQuery, canToggle, dataTestId, fetchTags, hideSingleTag, label, limit, multi = false, queryId, setBlockData, setBlockQuery, showAllTag, singleRow: singleRowOverride, tags, topicId, }) => {
    const breakpoint = useBreakpoint();
    const singleRow = false;
    const { s__ } = useI18n();
    const theme = useTheme();
    const updatedThemeForOutboxedFontBrightness = useUpdateThemeWithFontBrightness(theme, theme.themeVariables.outboxedFontBrightness);
    const effectiveTags = useGetTags({
        fetchTags,
        queryId,
        tags,
        topicId,
    });
    const selectedTags = Object.keys(blockQuery !== null && blockQuery !== void 0 ? blockQuery : {});
    useEffect(() => {
        setBlockData(isEmpty(blockQuery) ? null : blockQuery);
    }, [blockQuery, setBlockData]);
    const handleTagClick = useCallback((newTags) => {
        const filteredTags = effectiveTags.filter(({ name }) => newTags.includes(name));
        let result = null;
        for (const { query: tagQuery } of filteredTags) {
            result = mergeWith(null, result, tagQuery, concatArraysCustomizer);
        }
        setBlockQuery(result);
    }, [effectiveTags, setBlockQuery]);
    if ((effectiveTags === null || effectiveTags === void 0 ? void 0 : effectiveTags.length) <= (hideSingleTag ? 1 : 0)) {
        return null;
    }
    return (_jsxs(Box, { "data-testid": dataTestId, display: "block", children: [label ? (_jsx(ThemeProvider, { theme: updatedThemeForOutboxedFontBrightness, children: _jsx(Box, { mb: 2, children: _jsx(Label, { id: blockId, multiline: false, position: "top", required: false, children: label }) }) })) : (_jsx(ScreenReadersContent, { id: blockId, children: s__('Accessibility|Filter by category') })), _jsx(TagsFilters, { canToggle: canToggle, labelledBy: blockId, limit: singleRow ? undefined : limit, multi: multi, onClick: handleTagClick, selectedTags: selectedTags, showAllTag: showAllTag, singleRow: singleRow, tags: effectiveTags })] }));
};
//# sourceMappingURL=index.js.map